






































































































































































import { Component, Mixins } from 'vue-property-decorator';
import OverviewMixin from '@/mixins/OverviewMixin';
import FieldDefs from './FieldDefs';
import { OverviewLayoutITF, FixedFilter } from '@/interfaces';

@Component
export default class DeviceReportsOverview extends Mixins(OverviewMixin) {
  public tableCfg = FieldDefs;
  public fixedFilter: FixedFilter = {};
  public dialogExportOverview = false;
  public dialogRec = {};
  public uploadDialogValue = false;

  get enableExportOverview() {
    return (this.dialogRec as any).devicereportlayout_id;
  }

  public async exportOverview() {
    const data = {
      filter: this.getFilterValues(),
      sort: this.getSortString(),
      devicereportlayout_id: (this.dialogRec as any).devicereportlayout_id
    };
    const ref = this.$refs.overview as any;
    this.api.downloadAction(
      this.$store,
      '/devicereports/export_overview/',
      data
    );
  }

  public async downloadUnsignedDocs(docType: string) {
    const data = {
      doc_type: docType,
      filter: this.getFilterValues(),
      sort: this.getSortString()
    };
    this.api.downloadAction(
      this.$store,
      '/devicereports/download_unsigned_docs/',
      data
    );
  }

  public async downloadSignedDocs(docType: string) {
    const data = {
      filter: this.getFilterValues(),
      sort: this.getSortString()
    };
    this.api.downloadAction(
      this.$store,
      '/devicereports/download_signed_docs/',
      data
    );
  }

  public async uploadSignedDocs() {
    const ref: any = this.$refs.upload;
    // Only execute when at least 1 file is selected
    if (ref.files.length > 0) {
      ref.errorMessages = '';
      const formData = new FormData();
      for (const x of Object.keys(ref.files)) {
        const file: Blob = ref.files[x];
        formData.append('file', file);
      }
      const response = await this.api.uploadFile(
        this.$store,
        '/devicereports/upload_signed_docs/',
        formData
      );
      ref.files = [];
      this.uploadDialogValue = false;
      // Update overview
      (this.$refs.overview as unknown as OverviewLayoutITF).tableUpdateData();
    }
  }

  public markInvoicedState(state) {
    const overview = this.$refs.overview as any;
    const datatable = overview ? overview.$refs.datatable : null;
    const ids = Object.keys(datatable.selection);
    if (ids.length > 0) {
      this.api.postAction(this.$store, '/devicereports/set_invoiced_state/', {
        ids,
        state
      });
      datatable.selection = {};
      overview.tableUpdateData();
    }
  }

  public filterChanged() {
    (this.$refs.overview as unknown as OverviewLayoutITF).tableUpdateData();
    // Update store
    this.setDeviceGroupID(this.fixedFilter.devicegroup_id);
  }

  // Lifecycle Functions
  public mounted() {
    this.fixedFilter.devicegroup_id = this.getDeviceGroupID();
  }
}
